/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, KeyValue, Row } from '@folio/stripes/components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon, Loading } from '@folio/stripes-components';
import FieldViewBuilder from '../../../shared/FieldViewBuilder';
import DataProvider from '../../../providers/DataProvider';
import HelpeProvider from '../../../providers/HelpeProvider';
import useControlledVocab from '../../../hooks/useDataQueries';

function ViewItemTemplate({ itemData, templateTypeId }) {
  const { data, pending } = useControlledVocab();
  const intl = useIntl();

  const defaultTemplate = useMemo(() => {
    if (!pending) {
      return data.templates.find((template) => template.isDefault === true);
    }
    return {};
  }, [pending]);

  const currentTemplate = useMemo(() => {
    if (!pending) {
      return data.templates.find((template) => template.id === templateTypeId);
    }
    return {};
  }, [data.templates, pending, templateTypeId]);

  const localizedTemplateName = useMemo(() => {
    if (!pending) {
      return (currentTemplate || defaultTemplate)?.name?.find(
        (field) => field?.locale === intl.locale,
      )?.value;
    }
    return '';
  }, [pending, templateTypeId]);

  return (
    <DataProvider>
      <HelpeProvider>
        {pending && <Loading size="large" />}
        {!pending && (
          <div>
            <Row>
              <Col xs={12}>
                <KeyValue
                  label={
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.instanceWizard.instanceData.fields.templateType.label"
                      defaultMessage="Template type"
                    />
                  }
                  value={
                    <Icon icon={currentTemplate?.icon || 'document'}>
                      {localizedTemplateName}
                    </Icon>
                  }
                />
              </Col>
            </Row>
            <FieldViewBuilder
              data={{
                ...itemData,
                itemHrid: itemData.hrid,
                itemDiscoverySuppress: itemData.discoverySuppress,
                itemFormerIds: itemData.formerIds,
                itemStatisticalCodeIds: itemData.statisticalCodeIds,
                itemAdministrativeNotes: itemData.administrativeNotes,
                'materialType.id': itemData.materialType?.id,
                'permanentLocation.id': itemData.permanentLocation?.id,
                'temporaryLocation.id': itemData.temporaryLocation?.id,
                'permanentLoanType.id': itemData.permanentLoanType?.id,
                'temporaryLoanType.id': itemData.permanentLoanType?.id,
                'status.name': itemData.status.name,
              }}
              template={currentTemplate || defaultTemplate}
              entityType="items"
              controlledVocab={data}
            />
            <div />
          </div>
        )}
      </HelpeProvider>
    </DataProvider>
  );
}

ViewItemTemplate.propTypes = {
  itemData: PropTypes.object,
  templateTypeId: PropTypes.string,
};

export default ViewItemTemplate;
